export default "__VITE_ASSET__C$wG6tDB__"